import { render, staticRenderFns } from "./add_user.vue?vue&type=template&id=2cd880c1"
import script from "./add_user.vue?vue&type=script&lang=js"
export * from "./add_user.vue?vue&type=script&lang=js"
import style0 from "./add_user.vue?vue&type=style&index=0&id=2cd880c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports